import React from 'react';
import KeystoneLogo from '../components/KeystoneLogo';

/**
 * Internal route for rasterizing logo lockups to PNG via Playwright.
 * Each variant is sized to render cleanly at 2048×height when viewport set to 2048.
 */
export default function LogoRender() {
  // size = pixel height of mark, wordmark scales accordingly
  const variants = [
    { id: 'horizontal-light', layout: 'horizontal', variant: 'light', tagline: true, bg: '#FFFFFF' },
    { id: 'horizontal-light-notag', layout: 'horizontal', variant: 'light', tagline: false, bg: '#FFFFFF' },
    { id: 'horizontal-dark', layout: 'horizontal', variant: 'dark', tagline: true, bg: '#0A2540' },
    { id: 'horizontal-dark-notag', layout: 'horizontal', variant: 'dark', tagline: false, bg: '#0A2540' },
    { id: 'stacked-light', layout: 'stacked', variant: 'light', tagline: true, bg: '#FFFFFF' },
    { id: 'stacked-dark', layout: 'stacked', variant: 'dark', tagline: true, bg: '#0A2540' },
    { id: 'mark-light', layout: 'mark', variant: 'light', tagline: false, bg: 'transparent' },
    { id: 'mark-dark', layout: 'mark', variant: 'dark', tagline: false, bg: 'transparent' },
  ];

  return (
    <div style={{ background: '#E5E7EB', minHeight: '100vh', padding: 32, fontFamily: 'Inter, sans-serif' }}>
      {variants.map((v) => (
        <div
          key={v.id}
          id={`render-${v.id}`}
          data-variant={v.id}
          style={{
            display: 'inline-block',
            background: v.bg,
            padding: 64,
            margin: 24,
            borderRadius: 12,
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          }}
        >
          <KeystoneLogo
            height={v.layout === 'mark' ? 512 : 240}
            variant={v.variant}
            layout={v.layout}
            showTagline={v.tagline}
          />
        </div>
      ))}
    </div>
  );
}
